import { BasicPaginationParams, DateISOString } from 'domain/Common';
import { CommunityId } from 'domain/CommunityId';

export enum InsightsReportStatus {
  Creating = 'CREATING',
  Created = 'CREATED',
  Error = 'ERROR',
}

export type InsightsReportAssociatedItem = {
  id: number;
  name: string;
  date: string;
  participantsCount: number;
};

export type InsightsReportData = {
  id: string;
  name: string;
  associatedItems: InsightsReportAssociatedItem[];
  status: InsightsReportStatus;
  createdAt: DateISOString;
  anonymityFilterEnabled: boolean;
  anonymityThreshold?: number;
  pin?: string;
};

export type GetReportSourcesParams = BasicPaginationParams & { communityId: CommunityId };

export type ReportSource = {
  name: string;
  id: number;
  guestCount: number;
};

export type CreateInsightsReportParams = {
  ids: (number | undefined)[];
  selectAll: boolean;
};

export type ValidateReportPinPayload = {
  reportId: string;
  pin: string;
};
